import React, { FC, ReactNode } from 'react';
import Text from '@ingka/text';

const SectionHeading: FC<{ children: ReactNode }> = ({ children }) => (
  <Text
    tagName="h3"
    textStyle="Heading.S"
    style={{ marginBottom: 0, marginTop: 24 }}
  >
    {children}
  </Text>
);

export default SectionHeading;
